import { AsyncPipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AddCartItemRQ } from '../../dto/request/shopping-cart.request';
import { VariantOptionValue } from '../../dto/response/common.response';
import {
  CartItem,
  ShoppingCart,
} from '../../dto/response/shopping-cart.response';
import { PixelService } from '../../service/pixel.service';
import { ShoppingCartService } from '../../service/shopping-cart.service';
import { AddCartItem } from '../../store/actions/shoppingCart.action';
import { ShoppingCartState } from '../../store/states/shoppingCart.state';
import { ButtonComponent } from '../widgets/button/button.component';
import { ImageFallbackDirective } from '../../directives/image-fallback.directive';
import { NotificationService } from '../../service/notification.service';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [AsyncPipe, NgClass, TranslateModule, ButtonComponent, RouterLink, ImageFallbackDirective],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
})
export class CartComponent {
  public cart: string = 'cart_sidebar';
  addToCartRQ: AddCartItemRQ;
  @Select(ShoppingCartState.shoppingCart)
  shoppingCart$: Observable<ShoppingCart>;
  private currency_symbol: string | undefined;
  hasStockIssues = false;

  constructor(
    private store: Store,
    public shoppingCartService: ShoppingCartService,
    private pixelSvc: PixelService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.shoppingCart$.subscribe((shoppingCart) => {
      console.log('after updated cartd ', shoppingCart);
      this.currency_symbol = shoppingCart.currency?.symbol;

      if (this.pixelSvc.facebookPixelExist) {
        const contentsPixel = shoppingCart.items.map(c => ({ id: c.id, qunatity: c.quantity, price: c.total_price.sale_price, currency: c.total_price.currency }));
        this.pixelSvc.trackFbPixel("AddToCart", { content_name: "cart", contents: contentsPixel, value: shoppingCart.total_price.sale_price, currency: shoppingCart.total_price.currency })
      }
      if (this.pixelSvc.tiktokPixelExist) {
        const contentsPixel = shoppingCart.items.map(c => ({ id: c.id, qunatity: c.quantity, price: c.total_price.sale_price, currency: c.total_price.currency }));
        this.pixelSvc.trackTiktokPixel("AddToCart", { content_name: "cart", contents: contentsPixel, value: shoppingCart.total_price.sale_price, currency: shoppingCart.total_price.currency })
      }

      // GOOGLE ANALYTICS (internal + custom)
      if (this.pixelSvc.googleAnalyticsExist) {
        const itemsGa4 = shoppingCart.items.map(c => ({
          item_id: c.id,
          item_name: c.title,
          price: c.total_price.sale_price,
          quantity: c.quantity
        }));

        this.pixelSvc.trackGoogleAnalytics('add_to_cart', {
          value: shoppingCart.total_price.sale_price,
          currency: shoppingCart.total_price.currency,
          items: itemsGa4
        });
      }

      // GOOGLE ADS
      if (this.pixelSvc.googleAdsExist) {
        this.pixelSvc.trackGoogleAdsConversion({
          value: shoppingCart.total_price.sale_price,
          currency: shoppingCart.total_price.currency
        });
      }

      // Check for stock issues
      this.hasStockIssues = shoppingCart.items?.some(item => item.has_stock_issue) || false;
    });
  }

  cartToggle(open: boolean) {
    return (this.shoppingCartService.sideBarOpen = open);
  }

  updateQuantity(item: CartItem, number: number) {
    this.addToCartRQ = {
      product_id: item.id,
      sku_id: item.sku_id ? item.sku_id : null,
      quantity: number,
    };

    console.log('addToCart', this.addToCartRQ);
    this.store.dispatch(new AddCartItem(this.addToCartRQ)).subscribe({
      error: (err) => this.notificationService.handleBackendError(err)
    });
  }

  formatVariantOptions(variant_option_value: VariantOptionValue | undefined) {
    if (
      !variant_option_value ||
      Object.keys(variant_option_value).length === 0
    ) {
      return ''; // Devuelve una cadena vacía si el objeto está vacío
    }
    const valuesArray = Object.values(variant_option_value);
    return valuesArray.join('/');
  }

  delete(item: CartItem) {
    this.addToCartRQ = {
      product_id: item.id,
      sku_id: item.sku_id ? item.sku_id : null,
      quantity: -1 * item.quantity,
    };

    console.log('delete', this.addToCartRQ);
    this.store.dispatch(new AddCartItem(this.addToCartRQ)).subscribe({
      error: (err) => this.notificationService.handleBackendError(err)
    });
  }

  getCurrency() {
    return this.currency_symbol;
  }

  handleImageError(event: any) {
    event.target.src = '/assets/images/placeholder/product.png';
  }
}

